import { environment } from '@environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { VesselDetails, VesselEntry, RecordType } from '@models';

@Injectable({ providedIn: 'root' })
export class VesselService {
  private http = inject(HttpClient);

  endpoint = `${environment.kinkoHost}/dataset/${environment.vesselDatasetId}/record/`;

  addVessel(name: string) {
    return this.http.post<VesselEntry>(
      this.endpoint,
      {
        type: RecordType['vessel'],
        content: {
          name: name,
        } as VesselDetails,
      } as VesselEntry,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  getVessel(id: string) {
    return this.http.get<VesselEntry>(this.endpoint + id, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  updateVessel(id: string, vessel: VesselEntry) {
    return this.http.put<VesselDetails>(this.endpoint + id, vessel, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    });
  }

  removeVessel(id: string) {
    return this.http.delete(this.endpoint + id, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }
}
